module.exports = __webpack_public_path__ + "img/boiler-repair.20d45ed2.webp";